goog.provide('el8.appanalytics.dialog.bulkLetters');

goog.require('el8.uiwidget.ReactDialog');

el8.appanalytics.dialog.bulkLetters = (function() {

    var that = new el8.uiwidget.ReactDialog({
        title: 'Send Bulk Letter',
        autoHeight: true,
        modal: true,
        id: 'bulk-letters-dialog',
        reactComponentFn: function(id, props) {
            el8React.renderBulkLettersDialog(id, props);
        },
        width: 659,
        reactProps: {},
        showXButton: true
    });
    return that;
})();
